import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { Loader } from '@/shared/ui';
import {
  selectMetaIsLoaded,
  selectMetaIsLoading,
  setupColumnsMeta,
} from '../../model/slice';
import type { DataConfig } from '../../model/types';
import { useDataFetchers } from '../../model/useDataFetchers';
import { DataGrid } from '../DataGrid/DataGrid';

interface Props {
  preset: unknown;
  isReadonly?: boolean;
  onReorderDimensions?: (info: {
    id: string;
    oldIndex: number;
    newIndex: number;
  }) => void;
  onReorderMetrics?: (info: {
    id: string;
    oldIndex: number;
    newIndex: number;
  }) => void;
  onColumnsWidthChange?: (columnName: string, newWidth?: number) => void;
}

export function DashboardWidget({
  preset,
  isReadonly = true,
  onReorderDimensions = () => {},
  onReorderMetrics = () => {},
  onColumnsWidthChange = () => {},
}: Readonly<Props>) {
  const config = preset as DataConfig;
  const dispatch = useAppDispatch();
  const metaIsLoaded = useAppSelector(selectMetaIsLoaded);
  const metaIsLoading = useAppSelector(selectMetaIsLoading);

  useEffect(() => {
    dispatch(setupColumnsMeta());
  }, [dispatch]);

  const { onGetRows, onGetTotal, onGetTreeData, onGetMinMax } =
    useDataFetchers(config);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      <Loader active={metaIsLoading} />
      {metaIsLoaded && (
        <DataGrid
          config={config}
          onGetMinMax={onGetMinMax}
          onGetTotal={onGetTotal}
          onGetRows={onGetRows}
          onGetTreeData={onGetTreeData}
          onReorderDimensions={onReorderDimensions}
          onReorderMetrics={onReorderMetrics}
          onColumnsWidthChange={onColumnsWidthChange}
          isReadonly={isReadonly}
        />
      )}
    </Box>
  );
}
